<template>
  <div>
    <div class="card" v-if="selected_filters.length == 0">
      <div class="card-body">
        <p>
          <span>{{ 'no_filters_added' | t }}</span>
        </p>
      </div>
    </div>
    <div class="card mb-2" v-for="(filter, i) in selected_filters">
      <div class="card-body">
        <div class="form-group">
          <button class="btn btn-primary float-right" v-on:click="remove_filter(i)">{{ 'delete' | t }}</button>
        </div>
        <div class="form-group">
          <label>{{ 'filter' | t }}</label>
          <select class="form-control" v-model="filter.filter">
            <option v-for="f in available_filters" :value="f.filter">{{ f.description }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>{{ 'condition' | t }} - {{ 'condition_help_text' | t }}. ({{ 'blank_means_always_run' | t }})</label>
          <input class="form-control" v-model="filter.condition" />
        </div>
        <div class="form-group" v-for="param in find_params(filter)">
          <checkbox v-if="param.type == 'boolean'" :label="param.title" v-model="filter.params[param.title]"></checkbox>
          <template v-else>
            <label>{{ param.title }}</label>
            <input class="form-control" v-model="filter.params[param.title]" />
          </template>
        </div>
      </div>
    </div>
    <br />
    <button class="btn btn-primary" v-on:click="add_filter">{{ 'add_filter' | t }}</button><br /><br />
  </div>
</template>
<script>
export default {
  props: { value: Array },
  data: function () {
    return {
      selected_filters: this.value,
      available_filters: [
        {
          filter: 'Zip::TrimFilter',
          description: 'Trim whitespace around the zip-code',
          params: {}
        },
        {
          filter: 'Zip::NoWhitespaceFilter',
          description: 'Remove all whitespace in-and-around the zip-code',
          params: {}
        },
        {
          filter: 'Address::SanitizeAddressFilter',
          description: 'Sanitize all fields within the address, this includes removing non-latin letters and emojis',
          params: {}
        },
        {
          filter: 'CountryCode::ConversionFilter',
          description: 'Converts country codes. Parameter formatted like from,to:from,to:from,to',
          params: [{ title: 'country_conversions', type: 'string' }]
        }
      ]
    };
  },
  watch: {
    value(newValue) {
      this.selected_filters = newValue;
    }
  },
  methods: {
    find_params(filter) {
      let item = this.available_filters.find((x) => x.filter === filter.filter);
      if (item) {
        return item.params;
      }

      return [];
    },
    add_filter() {
      this.selected_filters.push({ filter: '', condition: '', params: {} });
    },
    remove_filter(i) {
      this.selected_filters.splice(i, 1);
    }
  }
};
</script>
